import * as React from 'react';
import { DevicePropsType } from '../../types';
import { WaveBlockShowcaseBrowserStyles } from './styles';

const WaveBlockShowcase : React.StatelessComponent<DevicePropsType> =
  ( props : DevicePropsType ) => {
    return (
      <WaveBlockShowcaseBrowserStyles />
    );
  };

export default WaveBlockShowcase;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Device/devices/WaveBlockShowcase/WaveBlockShowcase.tsx